import React, { Dispatch, forwardRef } from 'react';

import { UpperRow } from './upper-row';
import { ExportControl } from './export-control';
import { FiltersGroups } from 'constants/filters';
import { ColumnsVisibility } from './columns-visibility';
import { FiltersChips } from 'components/molecules/filters-chips-group';

import styles from './styles.module.css';

interface IControlsProps {
  search: string | null;
  searchHandler: Dispatch<string>;
  exportTable: Dispatch<string>;
}

const Controls = forwardRef<HTMLDivElement, IControlsProps>(({ exportTable, ...rest }, ref) => {
  return (
    <div ref={ref} className={styles.wrapper}>
      <UpperRow {...rest} />
      <div className={styles.row}>
        <div>
          <FiltersChips filtersGroup={FiltersGroups.TepLeases} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ExportControl exportTable={exportTable} />
          <ColumnsVisibility />
        </div>
      </div>
    </div>
  );
});

Controls.displayName = 'Controls';

export default Controls;
